import {
  EpkModuleApiService,
  getFilteredData,
} from '~packages/epk-front-shared/api-client';
import type { Filters, Params } from '~packages/epk-front-shared/api-client';
import { Mode } from '~packages/json-api/client';

import getConstants from '@/constants';

const { isModeDevelopment } = getConstants();

const constructorParams = {
  className: 'EpguApiService',
  mode: isModeDevelopment ? Mode.Production : Mode.Production,
  needInit: isModeDevelopment,
};

export default class EpguApiService extends EpkModuleApiService {
  constructor() {
    super(constructorParams);
  }
  // async updateEPGU(data, path) {
  //   return await super.update(data, path);
  // }
  // async update(data: any, path: any) {
  //   return await this._sendRequest(
  //     this.pathUpdate + path,
  //     null,
  //     { method: this.requestMethodUpdate, body: JSON.stringify(data) },
  //     { method: 'update' }
  //   );
  // }
  async getCardItemEPGU(id: string | number) {
    return await this._sendRequest(
      this.pathFetch + 'order/' + id,
      null,
      { method: this.requestMethodFetch },
      { method: 'getCardItemEPGU' }
    );
  }
  async getFilteredData(filters: Filters, params: Params) {
    return await getFilteredData(this, filters, params);
  }
}
